export enum VtmnButtonVariantEnum {
  PRIMARY = 'primary',
  PRIMARY_REVERSED = 'primary-reversed',
  SECONDARY = 'secondary',
  SECONDARY_REVERSED = 'secondary-reversed',
  TERTIARY = 'tertiary',
  GHOST = 'ghost',
  GHOST_REVERSED = 'ghost-reversed',
  CONVERSION = 'conversion',
  DISRUPTIVE = 'disruptive',
}
